// @ts-ignore
import { jitsiLocalStorage } from '@jitsi/js-utils/jitsi-local-storage';
import { toState } from '../redux/functions';
import { MODE_DEV } from './constants';
/**
 * Gets the value of a specific React {@code Component} prop of the currently
 * mounted {@link App}.
 *
 * @param {IStateful} stateful - The redux store or {@code getState}
 * function.
 * @param {string} propName - The name of the React {@code Component} prop of
 * the currently mounted {@code App} to get.
 * @returns {*} The value of the specified React {@code Component} prop of the
 * currently mounted {@code App}.
 */
export function getAppProp(stateful, propName) {
    const state = toState(stateful)['features/base/app'];
    if (state) {
        const { app } = state;
        if (app) {
            return app.props[propName];
        }
    }
    return undefined;
}
// eslint-disable-next-line require-jsdoc
export function isDevModeOn() {
    const currentMode = jitsiLocalStorage.getItem('mode');
    // eslint-disable-next-line curly
    if (!currentMode)
        return false;
    return MODE_DEV.includes(currentMode.toLocaleLowerCase());
}
